// src/Dashboard/pages/user/Inscription/components/InscriptionKpis.jsx

import React from "react";
import {
  FaCheckCircle,
  FaClock,
  FaExclamationTriangle,
  FaRedoAlt,
  FaUsers,
} from "react-icons/fa";

const KPI_CARDS = [
  {
    key: "total",
    label: "Adhérents",
    icon: FaUsers,
    className:
      "border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-500/20 dark:bg-blue-500/10 dark:text-blue-300",
  },
  {
    key: "upToDate",
    label: "Dossiers à jour",
    icon: FaCheckCircle,
    className:
      "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300",
  },
  {
    key: "missing",
    label: "À compléter",
    icon: FaExclamationTriangle,
    className:
      "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-300",
  },
  {
    key: "waiting",
    label: "En validation",
    icon: FaClock,
    className:
      "border-indigo-200 bg-indigo-50 text-indigo-700 dark:border-indigo-500/20 dark:bg-indigo-500/10 dark:text-indigo-300",
  },
  {
    key: "renewal",
    label: "À renouveler",
    icon: FaRedoAlt,
    className:
      "border-orange-200 bg-orange-50 text-orange-700 dark:border-orange-500/20 dark:bg-orange-500/10 dark:text-orange-300",
  },
];

export default function InscriptionKpis({ stats, loading }) {
  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-5">
      {KPI_CARDS.map((card) => {
        const Icon = card.icon;

        return (
          <div
            key={card.key}
            className={`rounded-[24px] border px-4 py-4 shadow-sm ${card.className}`}
          >
            <div className="flex items-center justify-between gap-3">
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-white/70 dark:bg-white/10">
                <Icon />
              </span>

              <span className="text-2xl font-bold">
                {loading ? "…" : stats?.[card.key] ?? 0}
              </span>
            </div>

            <p className="mt-3 text-[11px] font-bold uppercase tracking-[0.16em] opacity-80">
              {card.label}
            </p>
          </div>
        );
      })}
    </div>
  );
}